import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { LinearProgress } from '@mui/material';
import useGlynt from '../components/hooks/useGlynt';
import TopBar from '../components/common/TopBar';
import ErrorMsg from '../components/common/ErrorMsg';
import { getIdFromUrl } from '../utils/getIdFromUrl';

// Auto forward the user to the first extraction in the extraction page if the extraction id is not provided
const ReviewPageWithoutExtractionId = () => {
  const { dpid, id } = useParams<{
    dpid: string;
    id: string;
  }>();

  const navigate = useNavigate();
  const glynt = useGlynt(dpid);

  const extractionBatchData = useQuery({
    queryKey: ['extractionBatch', id],
    queryFn: async () => (await glynt).extractionBatch.retrieve(id!),
    refetchOnWindowFocus: false
  });

  const status = extractionBatchData.status;

  useEffect(() => {
    if (!extractionBatchData.data?.extractions) return;
    if (extractionBatchData.status !== 'success') return;

    const firstExtractionUrl = extractionBatchData.data?.extractions[0];
    const firstExtractionId = firstExtractionUrl ? getIdFromUrl(firstExtractionUrl) : null;

    if (firstExtractionId) {
      navigate(`/data-pools/${dpid}/extraction-batch/${id}/review/${firstExtractionId}`, {
        replace: true,
      });
    }
  }, [status]);

  if (extractionBatchData.isPending) return <LinearProgress />;

  return (
    <>
      <LinearProgress />
    </>
  );
};

export default ReviewPageWithoutExtractionId;
